import { CdkScrollable } from "@angular/cdk/scrolling";
import { NgComponentOutlet } from "@angular/common";
import { Component, OnInit, Type, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";
import { DataSearchService } from "@tylertech/data-load-module";
import { IInfoCardData, ISearchCriteria } from "@tylertech/tyler-api-types";
import { IInfoCardCustomCard, InfoCardCustomCardMap } from "../../interfaces";
import { InfoCardComponent } from "../infoCard/infoCard.component";

export interface InfoCardSearchDialogData
{
    readonly criteria: ISearchCriteria<IInfoCardData>;

    /**
     * Optional custom cards keyed by search provider id. The caller supplies these because it owns
     * the candidate components; the dialog only knows how to render whatever it is handed.
     */
    readonly customCards?: InfoCardCustomCardMap;
}

@Component({
    selector: "info-card-search-dialog-component",
    templateUrl: "./infoCardSearchDialog.tmpl.html",
    imports: [
        BusyIndicatorComponent,
        CdkScrollable,
        InfoCardComponent,
        LayoutAlignDirective,
        LayoutDirective,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        NgComponentOutlet,
    ]
})
export class InfoCardSearchDialogComponent implements OnInit
{
    private readonly $dataSearchService = inject<DataSearchService<IInfoCardData>>(DataSearchService);

    private readonly customCards: InfoCardCustomCardMap;

    isLoaded: boolean;
    criteria: ISearchCriteria<IInfoCardData>;

    constructor()
    {
        const data = inject<InfoCardSearchDialogData>(MAT_DIALOG_DATA);

        this.criteria = data.criteria;
        this.customCards = data.customCards;
    }

    get HasResults(): boolean { return this.criteria.SearchResult?.length > 0; }
    get cardProviderId(): string { return this.criteria.SearchProviderId; }

    get headerCard(): Type<IInfoCardCustomCard> { return this.customCards?.[this.cardProviderId]?.header; }
    get detailCard(): Type<IInfoCardCustomCard> { return this.customCards?.[this.cardProviderId]?.detail; }

    ngOnInit(): void
    {
        if (!this.criteria.Settings)
        {
            this.criteria.Settings = {};
        }
        this.criteria.Settings.Add = this.criteria.Settings.Add || false;
        this.criteria.Settings.NotForSearchView = this.criteria.Settings.NotForSearchView || true;
        this.criteria.Settings.IgnoreAdditionalInfo = this.criteria.Settings.IgnoreAdditionalInfo || true;

        this.$dataSearchService.Search(this.criteria)
            .then((result: ISearchCriteria<IInfoCardData>): void =>
            {
                result.SearchResult.forEach(infocard =>
                {
                    infocard.Metadata = result.Metadata;
                });
                this.criteria = result;
            })
            .finally(() =>
            {
                this.isLoaded = true;
            });
    }
}
